import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getShows } from 'redux/slices/shows'
import { fetchShowsBySeriesId } from 'redux/slices/shows/thunks'
import { useParams, useHistory } from 'react-router-dom'
import { useStyles } from './styles'
import ShowCard from 'components/common/ShowCard/ShowCard'
import { getShowsBySeriesId } from 'utils/show'
import ReactPixel from 'react-facebook-pixel'
import ReactGA from 'react-ga'

const Hub: React.FC = () => {
    const shows = useSelector(getShows)
    const dispatch = useDispatch()
    const { seriesId } = useParams()
    const history = useHistory()
    const filteredShows = getShowsBySeriesId(shows)(seriesId)
    const classes = useStyles({ items: filteredShows.length })

    useEffect(() => {
        if (shows && !shows.length) {
            history.push('/')
        }
    }, [shows, history])

    useEffect(() => {
        if (!shows) {
            dispatch(fetchShowsBySeriesId(seriesId))
        }
    }, [shows, dispatch, seriesId])

    useEffect(() => {
        const show = shows?.[0]
        if (show?.trackingIds?.facebookPixelId) {
            ReactPixel.init(show.trackingIds.facebookPixelId, undefined, { autoConfig: true, debug: false })
            ReactPixel.pageView()
        }
        if (show?.trackingIds?.googleTagId) {
            ReactGA.initialize(show.trackingIds.googleTagId)
            ReactGA.pageview(window.location.pathname + window.location.search)
        }
    })

    return (
        <div className={classes.wrapper}>
            {filteredShows && filteredShows.length && (
                <>
                    <div
                        className={classes.coverImg}
                        style={{ backgroundImage: `url(${filteredShows[0].coverImgUrl})` }}
                    />
                    <div className={classes.content}>
                        {filteredShows
                            .filter(show => show.seriesId === seriesId)
                            .map(show => (
                                <div className={classes.showCardWrapper} key={show._id}>
                                    <ShowCard show={show} type="upcoming" />
                                </div>
                            ))}
                    </div>
                </>
            )}
        </div>
    )
}

export default React.memo(Hub)
